const PACK_TYPE_LABELS = {
  "0": "Challenge Packs",
  "1": "Hunt Packs",
  "2": "Quest Packs",
};

const typeValue = (value) => (value === "1" ? "Percentage" : "Flat");
const getUsedFor = (value) => (value === "1" ? "Admin" : "Users");

const normalizeDateForInput = (value) => {
  if (!value) return "-";
  const str = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
  if (str.includes("T")) return str.split("T")[0];

  const parsed = new Date(str);
  if (Number.isNaN(parsed.getTime())) return "-";
  return parsed.toISOString().split("T")[0];
};

const groupByPackType = (itemgroups) => {
  const groups = { "0": [], "1": [], "2": [] };
  (Array.isArray(itemgroups) ? itemgroups : []).forEach((item) => {
    const packType = String(item?.pack_type ?? "0");
    if (!groups[packType]) return;
    groups[packType].push(item);
  });
  return groups;
};

const DiscountDetailsModal = ({ discount }) => {
  if (!discount) {
    return <div className="text-center py-3 text-muted">No discount details found.</div>;
  }

  const groups = groupByPackType(discount.itemgroups);
  const statusLabel = discount.status === "1" ? "Active" : "Inactive";

  return (
    <div className="d-grid gap-3">
      <div className="table-responsive">
        <table className="table table-sm mb-0">
          <tbody>
            <tr>
              <th style={{ width: 200 }}>Discount Title</th>
              <td>{discount.discount_name || "-"}</td>
            </tr>
            <tr>
              <th>Discount Code</th>
              <td>{discount.discount_code || "-"}</td>
            </tr>
            <tr>
              <th>Discount Type</th>
              <td>{typeValue(discount.discount_type)}</td>
            </tr>
            <tr>
              <th>Discount Value</th>
              <td>
                {discount.amount ?? "-"}
                {discount.discount_type === "1" ? "%" : ""}
              </td>
            </tr>
            <tr>
              <th>Max Users</th>
              <td>{discount.max_users ?? "-"}</td>
            </tr>
            <tr>
              <th>Start Date</th>
              <td>{normalizeDateForInput(discount.startdate)}</td>
            </tr>
            <tr>
              <th>End Date</th>
              <td>{normalizeDateForInput(discount.enddate)}</td>
            </tr>
            <tr>
              <th>Used For</th>
              <td>{getUsedFor(discount.isAdmin)}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>
                <span className={`badge ${discount.status === "1" ? "bg-success" : "bg-secondary"}`}>
                  {statusLabel}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {Object.entries(PACK_TYPE_LABELS).map(([packType, label]) => {
        const items = groups[packType];
        if (!items.length) return null;

        return (
          <div key={`pack-group-${packType}`}>
            <h6 className="mb-2">
              {label} ({items.length})
            </h6>
            <div className="table-responsive">
              <table className="table table-bordered table-sm align-middle mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th className="text-center">Discounted Price</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr key={`${packType}-${item.pack_item_id}`}>
                      <td>{item.group_name || `#${item.pack_item_id}`}</td>
                      <td className="text-center">
                        {item.discounted_price != null ? item.discounted_price : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}

      {!groups["0"].length && !groups["1"].length && !groups["2"].length ? (
        <div className="text-muted">No packs are attached to this discount.</div>
      ) : null}
    </div>
  );
};

export default DiscountDetailsModal;
